<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Coleta Voluntária</h5>
      </div>
    </div>
    <hr>

    <div class="row" v-if="token.role === 'CA'">
      <div class="col">
        <router-link :to="`${route}/novo`" class="btn btn-block btn-primary btn-raised"  v-if="!token.somenteLeitura">
          + Adicionar uma nova coleta
        </router-link>
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <form v-on:submit.prevent="filtrar" v-if="token.role === 'CA'">
          <fieldset>
          <legend>Filtrar</legend>
          <div class="form-group">
            <label for="filtro">Login / Nome</label>
            <input v-model="filtro" id="filtro" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label for="atividade">Tipo</label>
            <select @change="filtrar" v-model="tipo" class="form-control" name="tipo" id="tipo">
              <option value="TODOS">TODOS</option>
              <option value="VET">VETERINÁRIO</option>
              <option value="AGR">AGRÍCOLA</option>
            </select>
          </div>
          <div class="form-group">
              <div class="form-check form-check-inline">
                <label class="form-check-label">
                  <input @change="filtrar" class="form-check-input" type="checkbox" name="filtrarPorData" id="filtrarPorData" v-model="filtrarPorData"> Filtrar por data?
                </label>
              </div>
              <label for="datafiltro">Data</label>
              <input :disabled="!filtrarPorData" @change="filtrar" type="date" name="datafiltro" id="datafiltro" v-model="datafiltro" class="form-control">
          </div>
          </fieldset>
        </form>
        <div class="row">
            <div class="col">
              <button
                class="btn btn-sm btn-success btn-raised btn-block"
                type="button"
                :disabled="!filtrarPorData && filtro === ''"
                @click="PrintElem('tablePrint')">Imprimir Lista</button>

                <table id="tablePrint" class="d-none">
                    <tbody>
                      <tr v-for="item in data" :key="item._id" >
                        <td >{{formata(item.data)}} - </td>
                        <td width="500px">{{item.usuario.login}} - {{item.usuario.nome}} <br></td>
                      </tr>
                    </tbody>
                </table>
            </div>
          </div>
      </div>
    </div>

    <div class="row"  v-if="token.role === 'CA'">
      <div class="col">
        <pie :chart-data="chartData1" :height="150"></pie>
        <button class="btn btn-sm btn-success btn-raised btn-block" type="button"  @click="export2image(0, 'Resumo Coletas')">Download Gráfico</button>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
          <div class="alert alert-warning" role="alert" v-if="data.length === 0">
            Nenhuma coleta registrada.
          </div>

          <div id="accordion" v-if="data.length > 0">
            <div class="card" v-for="item in data" :key="item._id" >
              <div class="card-header d-flex" :id="'H' + item._id" data-toggle="collapse" :data-target="'#D' + item._id">
                  <i class="material-icons">local_shipping</i>

                  <span class="ml-2">
                    {{formata(item.data)}} - {{item.usuario.login}} <br> {{item.usuario.nome}}
                    <br>
                    <a
                      class="btn btn-xs btn-success btn-raised"
                      :href="`${api}/api/v1${route}/pdf/${item._id}/${encodeURIComponent(item.usuario.nome)}.pdf?token=${jwt}`"
                      target="_blank">
                      Declaração
                    </a>
                  </span>


              </div>

              <div :id="'D'+item._id" class="collapse" data-parent="#accordion">
                <div class="card-body">
                    <ul class="list-group">
                      <li class="list-group-item list-group-item-action d-flex">
                        <i class="material-icons">build</i>Manutenção<span class="badge badge-primary badge-pill ml-2">{{item.manutencao}}</span>
                      </li>
                      <li class="list-group-item list-group-item-action d-flex">
                        <i class="material-icons">pets</i>Veterinários<span class="badge badge-primary badge-pill ml-2">{{item.vet}}</span>
                      </li>
                      <li class="list-group-item list-group-item-action d-flex">
                        <i class="material-icons">album</i>Pneus<span class="badge badge-primary badge-pill ml-2">{{item.pneu}}</span>
                      </li>
                      <li class="list-group-item list-group-item-action d-flex">
                        <i class="material-icons">wb_incandescent</i>Lâmpadas<span class="badge badge-primary badge-pill ml-2">{{item.lampada}}</span>
                      </li>
                      <li class="list-group-item list-group-item-action d-flex">
                        <i class="material-icons">info</i>Outros<span class="badge badge-primary badge-pill ml-2">{{item.outros}}</span>
                      </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col">
          <pagination :records="total" :options='pagOpts' :per-page="perPage" @paginate="setPage">
          </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import Pie from '../../../custom/Pie';

export default {
  components: { Pie },
  data() {
    return {
      data: [],
      route: '/residuos/coleta',
      page: 1,
      filtro: '',
      tipo: 'TODOS',
      datafiltro: moment().format('YYYY-MM-DD'),
      filtrarPorData: false,
      perPage: 10,
      total: 0,
      chartData1: null,
      pagOpts: this.$custom.pagOpts
    };
  },
  methods: {
    export2image: function(i, name) {
      let canvas = document
        .querySelectorAll('canvas')
        [i].toDataURL('image/png');
      let link = document.createElement('a');
      link.download = name;
      link.href = canvas;
      link.click();
    },
    remove(id) {
      this.$http.delete(`${this.route}/${id}`).then(() => {
        this.setPage(this.page);
      });
    },
    filtrar() {
      this.setPage(1);
    },
    formata(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    PrintElem(el)
    {
        var mywindow = window.open('', 'PRINT');

        mywindow.document.write(`<html><head><title>${document.title} - Coletas</title>`);
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>CAQUI - Coletas</h1>');
        mywindow.document.write(document.getElementById(el).innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    },
    setPage: function(page) {
      this.page = page;

      const skip = (page - 1) * this.perPage;
      const filtro = this.filtro;
      const tipo = this.tipo;
      const datafiltro = this.datafiltro;
      const filtrarPorData = this.filtrarPorData;

      if (filtro !== '' || filtrarPorData) {
        this.perPage = 999;
      }

      const limit = this.perPage;

      let url = `${this.route}/list`;
      if (this.token.role === 'CA') {
        url += 'CA';
      }

      this.$http.post(url, { skip, limit, filtro, tipo, datafiltro, filtrarPorData }).then(response => {
        this.data = response.data.data;
        this.total = response.data.total;

        if (this.token.role === 'CA') {
          let A = 0;
          let I = 0;

          response.data.graficos.forEach(r => {
            if (r._id === 'A') {
              A = r.qtd;
            }

            if (r._id === 'I') {
              I = r.qtd;
            }
          });

          this.chartData1 = {
            labels: [`${I} Inadimplentes`, `${A} Adimplentes`],
            datasets: [
              {
                backgroundColor: ['#d98609', '#0a823b'],
                data: [I, A]
              }
            ]
          };
        }
      });
    }
  },
  beforeMount() {
    this.setPage(1);
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// src/components/app/residuos/coleta/Home.vue